import { render, staticRenderFns } from "./newlyCompany.vue?vue&type=template&id=fdcf4546&scoped=true"
import script from "./newlyCompany.vue?vue&type=script&lang=js"
export * from "./newlyCompany.vue?vue&type=script&lang=js"
import style0 from "./newlyCompany.vue?vue&type=style&index=0&id=fdcf4546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcf4546",
  null
  
)

export default component.exports